import { ValuationApproachModel } from 'api';
import { VALUATIONS_PUBLIC_COMPANIES_APPROACH } from 'pages/ValuationsAllocation/common/constants/valuations';
import { gridShortDate } from 'utilities';

/**
 * Checks if market date has changed from initial value.
 * Used to trigger public comps data refresh when market conditions change.
 *
 * @param params - Current and initial date/currency values
 * @returns true if either date or currency has changed
 */
export const hasMarketDateChanged = (params: { currentDate: string; initialDate: string }): boolean => {
  const formattedCurrentDate = gridShortDate(params.currentDate);
  return formattedCurrentDate !== params.initialDate;
};

/**
 * Filters approaches to only public comps types.
 * Excludes calibration and other approach types.
 *
 * @param approaches - All valuation approaches
 * @returns Only public comps approaches
 */
export const filterPublicCompsApproaches = (approaches: ValuationApproachModel[]): ValuationApproachModel[] =>
  approaches.filter(approach => approach.approach_type === VALUATIONS_PUBLIC_COMPANIES_APPROACH);
